import { RawCriterionWeight } from "@Criteria/Model"


export function buildWeightsPageQueryV1(workspaceId: number, projectId: number, evalModelId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Weights.Queries.WeightsPageQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
	}
}



export function buildWeightsSetsByHierarchyIdQueryV1(workspaceId: number, criteriaHierarchyId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Weights.Queries.WeightsSetsByHierarchyIdQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'CriteriaHierarchyId': criteriaHierarchyId
	}
}

export function buildWeightsSetEditorQueryV1(workspaceId: number, criteriaHierarchyId: number, criteriaWeightsSetId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Weights.Queries.WeightsSetEditorQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'CriteriaHierarchyId': criteriaHierarchyId,
		'CriteriaWeightsSetId': criteriaWeightsSetId
	}
}

export function buildSurveyWeightsSetCreatorQueryV1(workspaceId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Weights.Queries.SurveyWeightsSetCreatorQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId
	}
}



export function buildWeightsSetQueryV1(workspaceId: number, criteriaHierarchyId: number, criteriaWeightsSetId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Weights.Queries.WeightsSetQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'CriteriaHierarchyId': criteriaHierarchyId,
		'CriteriaWeightsSetId': criteriaWeightsSetId
	}
}


export function buildNormalizedWeightsQueryV1(workspaceId: number, criteriaHierarchyId: number, weights: RawCriterionWeight[])
{
	return {
		'$type': 'TCh.Domain.Criteria.Weights.Queries.NormalizedWeightsQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'CriteriaHierarchyId': criteriaHierarchyId,
		'Weights': weights
	}
}

export function buildWeightsSetDependenciesQueryV1(workspaceId: number, criteriaWeightsSetId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Weights.Queries.WeightsSetDependenciesQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'CriteriaWeightsSetId': criteriaWeightsSetId
	}
}

export function buildWeightsSetWeightsViewerQueryV1(workspaceId: number, projectId: number, weightsSetId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Weights.Queries.WeightsSetWeightsViewerQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'WeightsSetId': weightsSetId
	}
}


export function buildSurveyWeightsViewerQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Weights.Queries.SurveyWeightsViewerQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId
	}
}

export function buildPanelistWeightsViewerQueryV1(workspaceId: number, projectId: number, evalModelId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Weights.Queries.PanelistWeightsViewerQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'ProjectUserId': projectUserId
	}
}

export function buildSurveyWeightsComparerQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Weights.Queries.SurveyWeightsComparerQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId
	}
}

export function buildWeightsSetsComparerQueryV1(workspaceId: number, projectId: number, evalModelId: number, weightsSetsIds: number[])
{
	return {
		'$type': 'TCh.Domain.Criteria.Weights.Queries.WeightsSetsComparerQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'WeightsSetsIds': weightsSetsIds
	}
}






